<template>
  <ODialog ref="dialog" :max-width="400" hideWhenLoading>
    <v-card v-if="variable != null">
      <ODialogBar title="Editar Variável" @close="dismiss" />
      <v-card-text class="pa-6">
        <v-form ref="theForm" v-model="isValid">
          <div>
            <v-text-field
              v-model="variable.code"
              label="Nome da variável"
              :rules="[isSet, notColon]"
            />
          </div>

          <ORow fill-x class="justify-space-between gap-6">
            <v-text-field
              v-model="variable.pgn"
              label="PGN (hex)"
              :rules="[isSet]"
            />

            <v-text-field
              v-model.number="variable.spnStart"
              label="SPN Start (0-63)"
              :rules="[isSet, numbersOnly]"
            />

            <v-text-field
              v-model.number="variable.spnLen"
              label="SPN Len (1-64)"
              :rules="[isSet, numbersOnly]"
            />
          </ORow>

          <ORow fill-x class="justify-space-between gap-6">
            <v-text-field
              v-model.number="variable.multiplier"
              label="Multiplicador"
              :rules="[isSet, numbersOnly]"
            />

            <v-text-field
              v-model.number="variable.divisor"
              label="Divisor"
              :rules="[isSet, numbersOnly]"
            />

            <v-text-field
              v-model.number="variable.opts"
              label="Flags (dec)"
              :rules="[isSet, numbersOnly]"
            />
          </ORow>

          <v-textarea
            v-model="variable.comments"
            label="Comentários"
            rows="3"
          />

          <v-switch
            v-model="variable.isInactive"
            label="Ocultar da lista (e.g. para histórico)"
          />
        </v-form>
      </v-card-text>
      <ODialogButtons class="pa-6" @apply="save" @cancel="dismiss" />
    </v-card>
  </ODialog>
</template>

<script>
import EditStore from './EditStore'
import { isSet } from 'oderon-vue/utils.js'

export default {
  components: {},
  data() {
    return {
      variable: null,
      isSet,
      isValid: false
    }
  },
  computed: {},
  methods: {
    open(id) {
      this.id = id
      this.isValid = false
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      this.variable = await EditStore.fetchVariable(this.id)
    },
    dismiss() {
      return this.$refs.dialog.$dismiss()
    },
    async save() {
      this.$refs.theForm.validate()
      if (this.isValid) {
        this.$rootLoading(async () => {
          await EditStore.updateVariable(this.variable)
          this.$snack('Salvo com sucesso')
        })
      }
    },
    numbersOnly(x) {
      if (x == null) return true
      return x.toString().match(/^\d*$/) ? true : 'Apenas números (decimal)'
    },
    notColon(x) {
      if (x == null) return true
      return x.toString().includes(':') ? 'Não pode conter dois-pontos' : true
    }
  }
}
</script>

<style lang="sass"></style>
